import {ListItemIcon, ListItemText, Menu, MenuItem, Tooltip} from "@mui/material";
import React from "react";
import {useStores} from "~/stores";
import {MatPartReviewRowState, ReviewChoice} from "~/services/classes/MaterializedClasses.ts";
import {ToolbarButton} from "@mui/x-data-grid";
import {CAT_EQ_OPERATOR, CAT_NEQ_OPERATOR} from "../filters/CategoryFilter.tsx";
import FilterIcon from "../../../../../../components/icons/svg/FilterIcon.svg?react";
import NoFilterIcon from "../../../../../../components/icons/svg/NoFilterIcon.svg?react";
import CancelIcon from "../../../../../../components/icons/svg/CloseCircleIcon.svg?react";
import {REVIEW_CHOICE_FIELD} from "~/pages/categorization/controllers/CategorizationReviewPageFilterController.ts";

export const ToolbarQuickFilters: React.FC = () => {
    const {categorizationReviewStore} = useStores();
    const filterController =
        categorizationReviewStore.reviewPageController.reviewPageFilterController;

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const noActionTaken = filterController.hasFilter("state", "isAnyOf", [
        MatPartReviewRowState.input,
        MatPartReviewRowState.ai,
    ]) && filterController.hasFilter(REVIEW_CHOICE_FIELD, "doesNotEqual", String(ReviewChoice.ACCEPT));
    const notReviewedActive = filterController.hasFilter("state", "isAnyOf", [
        MatPartReviewRowState.input,
        MatPartReviewRowState.ai,
    ]) && !filterController.hasFilter("review_choice", "doesNotEqual", String(ReviewChoice.ACCEPT));
    const onlyReviewedActive = filterController.hasFilter(
        "state",
        "is",
        MatPartReviewRowState.reviewed,
    );
    const onlyApprovedActive = filterController.hasFilter(
        "state",
        "is",
        MatPartReviewRowState.approved,
    );

    return (
        <>
            <Tooltip title="Quick filters">
                <ToolbarButton
                    id="toolbar-quick-filters-button"
                    color="primary"
                    onClick={handleOpen}
                >
                    <FilterIcon fontSize="small"/>
                </ToolbarButton>
            </Tooltip>
            <Menu
                id="toolbar-quick-filters-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem
                    onClick={() => {
                        filterController.toggleFilter([{
                            field: "state",
                            operator: "isAnyOf",
                            value: [MatPartReviewRowState.input, MatPartReviewRowState.ai],
                        }, {
                            field: REVIEW_CHOICE_FIELD,
                            operator: "doesNotEqual",
                            value: String(ReviewChoice.ACCEPT),
                        }]);
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        {noActionTaken ? (
                            <FilterIcon fontSize="small" color="primary"/>
                        ) : (
                            <NoFilterIcon fontSize="small"/>
                        )}
                    </ListItemIcon>
                    <ListItemText>Needs user action</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        filterController.toggleFilter([{
                            field: "state",
                            operator: "isAnyOf",
                            value: [MatPartReviewRowState.input, MatPartReviewRowState.ai],
                        }]);
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        {notReviewedActive ? (
                            <FilterIcon fontSize="small" color="primary"/>
                        ) : (
                            <NoFilterIcon fontSize="small"/>
                        )}
                    </ListItemIcon>
                    <ListItemText>Not reviewed</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        filterController.toggleFilter([{
                            field: "state",
                            operator: "is",
                            value: MatPartReviewRowState.reviewed,
                        }]);
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        {onlyReviewedActive ? (
                            <FilterIcon fontSize="small" color="primary"/>
                        ) : (
                            <NoFilterIcon fontSize="small"/>
                        )}
                    </ListItemIcon>
                    <ListItemText>Only reviewed</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        filterController.toggleFilter([{
                            field: "state",
                            operator: "is",
                            value: MatPartReviewRowState.approved,
                        }]);
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        {onlyApprovedActive ? (
                            <FilterIcon fontSize="small" color="primary"/>
                        ) : (
                            <NoFilterIcon fontSize="small"/>
                        )}
                    </ListItemIcon>
                    <ListItemText>Only approved</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        filterController.toggleCatNotEqualsPrevFilter();
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        {filterController.catNotEqualPrevFilterIsActive ? (
                            <FilterIcon fontSize="small" color="primary"/>
                        ) : (
                            <NoFilterIcon fontSize="small"/>
                        )}
                    </ListItemIcon>
                    <ListItemText>{CAT_NEQ_OPERATOR.label}</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        filterController.toggleCatEqualsPrevFilter();
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        {filterController.catEqualPrevFilterIsActive ? (
                            <FilterIcon fontSize="small" color="primary"/>
                        ) : (
                            <NoFilterIcon fontSize="small"/>
                        )}
                    </ListItemIcon>
                    <ListItemText>{CAT_EQ_OPERATOR.label}</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        filterController.clearFilters();
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        <CancelIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Clear</ListItemText>
                    {/*<Typography variant="body2" sx={{color: 'text.secondary'}}>*/}
                    {/*    <Cancel fontSize="small"/>*/}
                    {/*</Typography>*/}
                </MenuItem>
            </Menu>
        </>
    );
};
